/* eslint-disable no-unused-vars */
export enum UserRole {
  OWNER = 'owner',
  ADMIN = 'admin',
  VIEWER = 'viewer',
}

export enum PermissionAction {
  READ = 'read',
  WRITE = 'write',
}

export enum PermissionResource {
  ANALYTICS = 'analytics',
  APP_SUMO = 'app-sumo',
  CHATBOT = 'chatbot',
  ONBOARDING = 'onboarding',
  CUSTOMER_PORTAL = 'customer-portal',
  FAQ = 'faq',
  FACEBOOK = 'facebook',
  FEEDBACK = 'feedback',
  HISTORY = 'history',
  INGESTION = 'ingestion',
  KEYWORD = 'keyword',
  LIMITATION = 'limitation',
  LOCALE = 'locale',
  SCRAPER = 'scraper',
  SUBSCRIPTION = 'subscription',
  TAG = 'tag',
  TIMEZONE = 'timezone',
  ORGANIZATION = 'organization',
  IN_APP_NOTIFICATION = 'in-app-notification',
  WEB_PUSH = 'web-push',
  API_KEY = 'api-key',
  MCP_SERVER = 'mcp-server',
  WORDPRESS = 'wordpress',
  TERMINOLOGY_MAPPING = 'terminology-mapping',
}

export const VIEWER_BLOCKED_PATHS = [
  '/dashboard/appearance',
  '/dashboard/install',
  '/dashboard/organization',
  '/dashboard/developer',
  '/dashboard/wordpress',
  '/dashboard/facebook',
  // '/checkout/resubscribe',
  '/checkout/pre-dashboard',
  '/checkout/pay',
  '/checkout/success',
  '/checkout/start',
  '/appsumo/link',
]

export const ADMIN_BLOCKED_PATHS = [
  // '/checkout/resubscribe',
  '/checkout/pre-dashboard',
  '/checkout/pay',
  '/checkout/success',
  '/checkout/start',
  '/appsumo/link',
]

export enum UserIntention {
  EXTERNAL_FAQ = 'external_faq',
  LEAD_GENERATION = 'lead_generation',
  INTERNAL_KNOWLEDGE = 'internal_knowledge',
  OTHER = 'other',
}
